import type { ReactNode } from "react";
import { useWidgetConfig } from "../../features/customization/hooks/use-widget-config";
import { LocaleProvider } from "./provider";

interface LocaleConfigWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that reads locale config from widget config
 * and passes it to LocaleProvider
 */
export function LocaleConfigWrapper({ children }: LocaleConfigWrapperProps) {
  const { config } = useWidgetConfig();

  // Extract locale config from appearance settings
  const configLocale = config?.appearance?.locale;

  return <LocaleProvider configLocale={configLocale}>{children}</LocaleProvider>;
}
